import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { ChangePassEventType } from '../change-pass.event.type';
import { ChangePassService } from '../change-pass.service';
import { ChangePass } from '../model/change-pass';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-reset',
	templateUrl: './reset.component.html',
	styleUrls: ['./reset.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ResetComponent implements OnInit, OnDestroy {

	@Input() submited: boolean;
	@Input() changePassData: ChangePass;
	@Output() onSetForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	public formPass: FormGroup;
	public formSignature: FormGroup;
	public inputToResetPass: any;
	public active = false;
	public disabled = false;
	private view = '[data-component="reset"]';
	public isAttendant = false;

	constructor(private formBuilder: FormBuilder,
		private themeService: ThemeService,
		private autenticationService: AutenticationService,
		private changePassService: ChangePassService) {
		this.formPass = formBuilder.group({
			oldPassword: ['', [Validators.required]],
			passwords: this.formBuilder.group({
					password: ['', [Validators.required]],
					repeatPassword: ['', [Validators.required]],
			}, {validator: this.passwordConfirming}),
		});

	}

	passwordConfirming(c: AbstractControl): { invalid: boolean } {
		if (c.get('password').value !== c.get('repeatPassword').value) {
				return {invalid: true};
		}
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen( ChangePassEventType.STEPS.CHANGE_PASS_RESET, () => {
			this.inputToResetPass = this.formPass.get('oldPassword');
			this.onSetForm.emit(this.formPass);
			this.active = true;
			this.show();
		});

		AppEventDispatcher.listen(ChangePassEventType.SEND.CHANGE_PASS_SEND, () => {
			this.send();
		});
	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	send() {

		this.submited = true;
		if (this.formSignature.valid) {

			this.preload(true);
			this.disabled = true;
			this.submited = false;

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);

			this.addAuthToken();

			this.autenticationService.sendDigitalSignature(this.formSignature.value.eletronicSignature).subscribe(d => {
				if (d.Sucesso) {

					this.preload(true);

					let secondTime = 1;
					const secondTimeLoader = setInterval(() => {
						secondTime++;
					}, 1000);

					this.changePassService.changePassword(this.formPass.value).subscribe(data => {

						if (data.Sucesso) {
							this.changePassData.success = true;
						} else {
							this.changePassData.success = false;
						}

						this.changePassData.message = data.Mensagem;
						this.checkAfterSend(timeLoader, time);
						this.disabled = false;

						this.hide();


					}, error => {
						this.checkAfterSend(timeLoader, time);
						this.disabled = false;

						if (error.error.Tipo !== 'tokenDatablinkValidado') {
							this.hide();
							this.changePassData.success = false;
							this.changePassData.message = error.error.Mensagem;
						} else {
							AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
							AppEventDispatcher.dispatch(ChangePassEventType.ERROR, { step: ChangePassEventType.SEND.CHANGE_PASS_SEND });
						}


					});
				}
			}, error => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				AppEventDispatcher.dispatch(ChangePassEventType.ERROR, { step: ChangePassEventType.SEND.CHANGE_PASS_SEND });
				this.disabled = false;
			});
		}

	}

	hide() {
		TweenMax.delayedCall(1, () => {
			AppEventDispatcher.dispatch(ChangePassEventType.STEPS.CHANGE_PASS_WARNING, { show: true });

			TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ChangePassEventType.SEND.CHANGE_PASS_SEND);
		AppEventDispatcher.removeListener( ChangePassEventType.STEPS.CHANGE_PASS_RESET);
	}

	setInput(input) {
		if (input === 'oldPassword') {
			this.inputToResetPass = this.formPass.get(input);
		} else {
			this.inputToResetPass = this.formPass.get(['passwords', input]);
		}
	}

	setInputValueFromKeyPad(val) {
		if (this.inputToResetPass.value.length <= 5) {
			this.inputToResetPass.setValue(this.inputToResetPass.value.toString() + val[0].toString());
			this.showNumPad();
		}
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;
	}

	changeToRepeatPass() {
		if (this.formPass.get(['passwords', 'password']).value && !this.formPass.get(['passwords', 'repeatPassword']).value) {
			$('[data-component="reset"]').find('.repeat-password').focus();
		} else {
			$('[data-component="reset"]').find('.old-password').focus();
		}
	}

	checkAfterSend(timeLoader, time) {

		if (time > 3) {
			this.preload(false);
		}	else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
			});
		}
		clearInterval(timeLoader);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="reset"] .content', show: active, delay: delay});
	}
	onCorrect() {
		this.inputToResetPass.setValue('');
	}

	showNumPad() {
		TweenMax.to('[data-component="reset"] .reset-pass [data-component="virtual-num-pad"]', .5, { autoAlpha: 1 });
	}

	hideNumPad(e) {
		if (e.relatedTarget === null || e.relatedTarget.className !== 'keyboard-button') {
			TweenMax.to('[data-component="reset"] .reset-pass [data-component="virtual-num-pad"]', .5, { autoAlpha: 0 });
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/reset/reset.component.ts